import React from 'react';
import Form, { FormInstance } from 'antd/lib/form';
import ParListSelect from 'components/ParListSelect';
import FormInput from 'components/FormInput';
import { Col, DatePicker, Input, InputNumber, Radio, Row } from 'antd';
import Title from 'components/Title';
import ProductInput from 'pages/ProposalV3/PropDetail/ProductInput';
import GetLabel from 'DisplayFramework/components/GetLabel';
import moment from 'moment';
import InputRate from 'components/InputRate';
import { checkOfferUniqueness, CheckOfferUniquenessResponse } from 'services/pricing';
export type GeneralProductDataProps = {
  form: FormInstance;
  required: boolean;
  setIsChangePartnbdaysmax?: (any: boolean) => void; // Add validation callback
  setIsChangedurationmax?: (any: boolean) => void; 
};

const GeneralProductData = ({
  form,
  required,
  setIsChangePartnbdaysmax,
  setIsChangedurationmax
}: GeneralProductDataProps) => {
  return (
    <Form className="container-stepper mt-4" form={form}>
      <Title
        comcode="infoToComplete"
        level={4}
        className="ut-updateTP-title mb-7 mt-10"
      />
      {/* <Button onClick={logFormValues}> click here to debug</Button> */}

      <Row gutter={16} justify="space-between" align="top">
        {/* First Line */}
        <Col span={7}>
          {/* startdate to be verif */}
          <FormInput
            name="startdate"
            initialValue={moment()}
            className="font-size-13 "
            extra="JJ/MM/AAAA"
          >
            <DatePicker
              format={{
                format: 'DD/MM/YYYY',
                type: 'mask',
              }}
            />
          </FormInput>
        </Col>
        <Col span={8}>
          {/* prcode */}
          <FormInput
            name="prcode"
          >
            <ProductInput className="no-border-radius" />
            {/* <ParListSelect parcode="ASSETMODEL" /> */}
            {/* todo add productList */}
          </FormInput>
        </Col>
        <Col span={7}>
          {/* prcode */}
          <FormInput
            name="calculationmethod"
          >
            <ParListSelect parcode="INTCALC" />
            {/* todo add productList */}
          </FormInput>
        </Col>
      </Row>

      <Row gutter={16} style={{ marginTop: 16 }}>
        <Col span={8}>
          {/* N/A */}
          <FormInput
            name="offertarget"
          >
            <Radio.Group defaultValue="network">
              <Radio value="NETWORK" className="font-size-15 ml-4">
                <GetLabel label="network" />
              </Radio>
              <Radio value="BRANCH" className="font-size-15 ml-4">
                <GetLabel label="branch" />
              </Radio>
            </Radio.Group>
          </FormInput>
        </Col>
        {/* brand //// select multiple or no --- not exist in java */}
        {/* yes it is multiselect */}
        <Col span={16}>
          <FormInput name="brandlist" >
            <ParListSelect parcode="TPBRAND" modemultiple />
          </FormInput>
        </Col>
      </Row>

      <Row gutter={16} style={{ marginTop: 16 }}>
        {/* offercode not exist in java */}
        <Col span={8}>
          <FormInput
            name="offercode"
            rules={[
              {
                async validator(_, value) {
                  if (!value || value.length > 10) {
                    return Promise.reject(new Error('Le code ne doit pas dépasser 10 caractères'));
                  }

                  const offerlabel = '';
                  try {
                    const res = await checkOfferUniqueness({ offercode: value, offerlabel });
                    const data = res.data;
                    console.log('data', data)

                    if (data.codeUsed) {
                      return Promise.reject(new Error(data.codeMessage || 'Code déjà utilisé'));
                    }

                    return Promise.resolve();
                  } catch (err) {
                    return Promise.reject(new Error('Erreur lors de la vérification du code'));
                  }
                },
              },
            ]}
          >
            <Input />
          </FormInput>



        </Col>
        <Col span={16}>
          {/* { offerlabel } */}
          <FormInput
            name="offerlabel"
            rules={[
              {
                async validator(_, value) {
                  if (!value) return Promise.resolve();

                  const offercode = form.getFieldValue('offercode') || '';
                  try {
                    const res = await checkOfferUniqueness({ offercode, offerlabel: value });
                    const data = res.data;

                    if (data.labelUsed) {
                      return Promise.reject(new Error(data.labelMessage || 'Libellé déjà utilisé'));
                    }

                    return Promise.resolve();
                  } catch (err) {
                    return Promise.reject(new Error('Erreur lors de la vérification du libellé'));
                  }
                },
              },
            ]}
          >
            <Input />
          </FormInput>

        </Col>
      </Row>

      <Row gutter={16} style={{ marginTop: 16 }}>
        {/* Fourth Line */}
        <Col span={8}>
          <FormInput
            name="durationmax"
            rules={[
              {
                validator: (_, value, callback) => {
                  const partnbdaysmax = form.getFieldValue('partnbdaysmax');
                  if (value > 365) {
                    return Promise.reject(
                      new Error('La valeur ne peut pas dépasser 365')
                    );
                  }

                  return Promise.resolve();
                },
              },
            ]}
          >
            <InputNumber min={0} onChange={()=>{setIsChangedurationmax&&setIsChangedurationmax(true)}}/>
          </FormInput>
        </Col>

        <Col span={8}>
          <FormInput
            name="partnbdaysmax"
            rules={[
              {
                validator: (_, value) => {
                  const durationmax = form.getFieldValue('durationmax');
                  if (durationmax && value > durationmax) {
                    return Promise.reject(
                      new Error(
                        'Le nombre de jours participations doit être inférieur à la durée maximale'
                      )
                    );
                  }
                  return Promise.resolve();
                },
              },
            ]}
            getValueFromEvent={(e) => {
              const val = Number(e.target.value);
              if (isNaN(val)) return undefined;
              return val < 0 ? 0 : val;
            }}
          >
            <Input type="number" min={0} onChange={()=>{setIsChangePartnbdaysmax&&setIsChangePartnbdaysmax(true)}}/>
          </FormInput>
        </Col>
      </Row>

      <Row gutter={16} justify="space-between" align="middle" className="mt-8">
        {/* flagusegrossamount */}
        <Col span={8}>
          <FormInput
            name="flaguseassetgrossamount"
          >
            <Radio.Group>
              <Radio value className="font-size-15 ml-4">
                <GetLabel label="TTC" />
              </Radio>
              <Radio value={false} className="font-size-15">
                <GetLabel label="HT" />
              </Radio>
            </Radio.Group>
          </FormInput>
        </Col>
        <Col span={7}>
          {/* { o verif avec sarra } */}
          <FormInput
            name="financementType"
          >
            <Radio.Group>
              <Radio value="TOTAL" className="font-size-15 ml-4">
                <GetLabel label="total" />
              </Radio>
              <Radio value="PARTIAL" className="font-size-15">
                <GetLabel label="partial" />
              </Radio>
            </Radio.Group>
          </FormInput>
        </Col>

        <Form.Item
          noStyle
          shouldUpdate={(prev, curr) =>
            prev.financementType !== curr.financementType
          }
        >
          {({ getFieldValue }) => {
            const showFinPercent =
              getFieldValue('financementType') === 'PARTIAL';
            return showFinPercent ? (
              <FormInput
                name="finpercent"
                rules={[

                  {
                    validator: (_, value) => {
                      if (value >= 100) {
                        return Promise.reject(new Error('Le pourcentage ne doit pas dépasser 99'));
                      }
                      return Promise.resolve();
                    },
                  },
                ]}
              >
                <InputRate className="no-border-radius ut-wizard-form" />
              </FormInput>
            ) : null;
          }}
        </Form.Item>

        <Col span={7}>
          {/* { depreciation } */}
          <FormInput
            name="offerdepreciation"
          >
            <Radio.Group>
              <Radio value="DEPRECIABLE" className="font-size-15 ml-4 ">
                <GetLabel label="depreciable" />
              </Radio>
              <Radio value="INFINE" className="font-size-15">
                <GetLabel label="infine" />
              </Radio>
            </Radio.Group>
          </FormInput>
        </Col>
      </Row>
    </Form>
  );
};

export default GeneralProductData;
